import { Route } from 'vue-router'
import * as xcomMessengerClient from '@siteminder/xcom-messenger-client'
import config from '@/config'

const APP_NAME = 'AUTHX'
export const INTERCOM_COOKIES_CLEARED_KEY = 'intercom-cookies-cleared'

export const deleteIntercomCookies = () => {
  const cookies = document.cookie.split(';')

  // Extract base domain (e.g., 'siteminderlabs.com' from 'platform-dev-authx-login.dev.siteminderlabs.com')
  const hostnameParts = window.location.hostname.split('.')
  let baseDomain: string | undefined

  if (hostnameParts.length > 2) {
    baseDomain = `.${hostnameParts.slice(-2).join('.')}`
  }

  const domains = [baseDomain].filter(Boolean) as string[]

  // Delete Intercom cookies
  cookies.forEach((cookie) => {
    const cookieName = cookie.split('=')[0].trim()

    if (cookieName.startsWith('intercom-')) {
      domains.forEach((domain) => {
        ['/', ''].forEach((path) => {
          // Try both expires and max-age for better compatibility
          document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; max-age=0; path=${path}; domain=${domain}`
        })
      })
    }
  })

}

export const xcomMessenger = async (to: Route) => {
  // For better performance, exclude from authentication, pan data mfa/verification and sso pages to avoid unnecessary computing time on client side
  if (to.path === '/authenticate' || to.path.startsWith('/partners') || to.path.startsWith('/mfa/verification')) {
    return
  }

  const hostname = window.location.hostname.toLocaleLowerCase()
  const supportedDomains = (config.XCOM_MESSENGER_SUPPORTED_DOMAINS || '').split(',')

  // whitelist of supported domains
  if (!supportedDomains.includes(hostname)) {
    return
  }

  if (xcomMessengerClient.isInitialised()) {
    return
  }

  if (!config.XCOM_MESSENGER_INTERCOM_APP_ID) {
    return
  }

  try {
    if (!sessionStorage.getItem(INTERCOM_COOKIES_CLEARED_KEY)) {
      deleteIntercomCookies()
      sessionStorage.setItem(INTERCOM_COOKIES_CLEARED_KEY, 'true')
    }
  } catch {
    deleteIntercomCookies()
  }

  await xcomMessengerClient.createAnonymousClient({
    intercomAppId: config.XCOM_MESSENGER_INTERCOM_APP_ID,
    appName: APP_NAME,
  })

}
